// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emoji-button {\n   position: relative;\n}\n\n.swal2-popup.swal2-modal.swal2-show {\n   background: none;\n}\n", ""]);
// Exports
module.exports = exports;
